/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Items_Metadata_ValueInputs */

const id_items_metadata_value = /** @type {(inputs: Items_Metadata_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nilai`)
};

const ms_items_metadata_value = /** @type {(inputs: Items_Metadata_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nilai`)
};

const da_items_metadata_value = /** @type {(inputs: Items_Metadata_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Værdi`)
};

const de_items_metadata_value = /** @type {(inputs: Items_Metadata_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wert`)
};

const en_us2_items_metadata_value = /** @type {(inputs: Items_Metadata_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Value`)
};

const es_es2_items_metadata_value = /** @type {(inputs: Items_Metadata_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valor`)
};

const es_mx2_items_metadata_value = /** @type {(inputs: Items_Metadata_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valor`)
};

const fil_items_metadata_value = /** @type {(inputs: Items_Metadata_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Halaga`)
};

const fr_items_metadata_value = /** @type {(inputs: Items_Metadata_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valeur`)
};

const it_items_metadata_value = /** @type {(inputs: Items_Metadata_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valore`)
};

const hu_items_metadata_value = /** @type {(inputs: Items_Metadata_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Érték`)
};

const nl_items_metadata_value = /** @type {(inputs: Items_Metadata_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waarde`)
};

const no_items_metadata_value = /** @type {(inputs: Items_Metadata_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verdi`)
};

const pl_items_metadata_value = /** @type {(inputs: Items_Metadata_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wartość`)
};

const pt_br2_items_metadata_value = /** @type {(inputs: Items_Metadata_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valor`)
};

const pt_items_metadata_value = /** @type {(inputs: Items_Metadata_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valor`)
};

const ro_items_metadata_value = /** @type {(inputs: Items_Metadata_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valoare`)
};

const fi_items_metadata_value = /** @type {(inputs: Items_Metadata_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arvo`)
};

const sv_items_metadata_value = /** @type {(inputs: Items_Metadata_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Värde`)
};

const vi_items_metadata_value = /** @type {(inputs: Items_Metadata_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giá trị`)
};

const tr_items_metadata_value = /** @type {(inputs: Items_Metadata_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Değer`)
};

const cs_items_metadata_value = /** @type {(inputs: Items_Metadata_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hodnota`)
};

const bg_items_metadata_value = /** @type {(inputs: Items_Metadata_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Стойност`)
};

const ru_items_metadata_value = /** @type {(inputs: Items_Metadata_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Значение`)
};

const uk_items_metadata_value = /** @type {(inputs: Items_Metadata_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Значення`)
};

const ar_items_metadata_value = /** @type {(inputs: Items_Metadata_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`القيمة`)
};

const hi_items_metadata_value = /** @type {(inputs: Items_Metadata_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मान`)
};

const th_items_metadata_value = /** @type {(inputs: Items_Metadata_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ค่า`)
};

const ja_items_metadata_value = /** @type {(inputs: Items_Metadata_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`値`)
};

const zh_cn2_items_metadata_value = /** @type {(inputs: Items_Metadata_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`值`)
};

const zh_hant1_items_metadata_value = /** @type {(inputs: Items_Metadata_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`值`)
};

const ko_items_metadata_value = /** @type {(inputs: Items_Metadata_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`값`)
};

/**
* | output |
* | --- |
* | "Value" |
*
* @param {Items_Metadata_ValueInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const items_metadata_value = /** @type {((inputs?: Items_Metadata_ValueInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Items_Metadata_ValueInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_items_metadata_value(inputs)
	if (locale === "ms") return ms_items_metadata_value(inputs)
	if (locale === "da") return da_items_metadata_value(inputs)
	if (locale === "de") return de_items_metadata_value(inputs)
	if (locale === "en-US") return en_us2_items_metadata_value(inputs)
	if (locale === "es-ES") return es_es2_items_metadata_value(inputs)
	if (locale === "es-MX") return es_mx2_items_metadata_value(inputs)
	if (locale === "fil") return fil_items_metadata_value(inputs)
	if (locale === "fr") return fr_items_metadata_value(inputs)
	if (locale === "it") return it_items_metadata_value(inputs)
	if (locale === "hu") return hu_items_metadata_value(inputs)
	if (locale === "nl") return nl_items_metadata_value(inputs)
	if (locale === "no") return no_items_metadata_value(inputs)
	if (locale === "pl") return pl_items_metadata_value(inputs)
	if (locale === "pt-BR") return pt_br2_items_metadata_value(inputs)
	if (locale === "pt") return pt_items_metadata_value(inputs)
	if (locale === "ro") return ro_items_metadata_value(inputs)
	if (locale === "fi") return fi_items_metadata_value(inputs)
	if (locale === "sv") return sv_items_metadata_value(inputs)
	if (locale === "vi") return vi_items_metadata_value(inputs)
	if (locale === "tr") return tr_items_metadata_value(inputs)
	if (locale === "cs") return cs_items_metadata_value(inputs)
	if (locale === "bg") return bg_items_metadata_value(inputs)
	if (locale === "ru") return ru_items_metadata_value(inputs)
	if (locale === "uk") return uk_items_metadata_value(inputs)
	if (locale === "ar") return ar_items_metadata_value(inputs)
	if (locale === "hi") return hi_items_metadata_value(inputs)
	if (locale === "th") return th_items_metadata_value(inputs)
	if (locale === "ja") return ja_items_metadata_value(inputs)
	if (locale === "zh-CN") return zh_cn2_items_metadata_value(inputs)
	if (locale === "zh-Hant") return zh_hant1_items_metadata_value(inputs)
	return ko_items_metadata_value(inputs)
});
export { items_metadata_value as "items.metadata.value" }